import React from "react";
import "./Footer.css";
import { GrTwitter } from "react-icons/gr";
import { BsGithub } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";
import { AiFillLinkedin } from "react-icons/ai";
const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Krishan Kumar
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          href="https://www.linkedin.com/in/krishan-kumar-safi-024794224/"
          target="_blank"
        >
          <AiFillLinkedin />
        </a>
        <a href="https://github.com/Krishukr12" target="_blank">
          <BsGithub />
        </a>
        <a href="https://leetcode.com/krishukr/" target="_blank">
          <SiLeetcode />
        </a>
        <a href="https://twitter.com/KrishanSafi" target="_blank">
          <GrTwitter />
        </a>
      </div>
      <div className="footer__copyrihght">
        <small>&copy; Krishan . All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
